
$(function() {

    $(".product-section .option-box").on("click", function(){
        var $this = $(this);
        var radioInput = $this.find(".option-radio");
        var prodId = radioInput.attr("data-opt-id");
        var planId = radioInput.attr("data-opt-plan-id");
        console.log('planId',planId);
        var btn = $(".product-section #purchase_btn");
        radioInput.prop("checked", true);
        btn.attr("data-variant-id", prodId);

        if(planId) {
            btn.attr("data-selling-plan-id", planId);
        }else{
            btn.removeAttr("data-selling-plan-id");
        }
        
    });



  
    $('.atc-otp, .atc-subscription').on('click', function(event) {

            event.preventDefault(); 

            var $this = $(this); 
            
            var variantId = $this.data('variant-id');
            var quantity = $this.data('quantity');
            var sellingPlanId = $this.data('selling-plan-id'); 

            
            var item = {
                'id': variantId,
                'quantity': quantity
            };

            
            if (sellingPlanId) {
                item.selling_plan = sellingPlanId;
            }

        
            var formData = {
                'items': [item]
            };
            
            clearCart(formData, function(){

                $.ajax({
                    url: '/cart/add.js',
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(formData)
                })
                .done(function(response) {
                    window.location.href = '/checkout';
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                
                    var errorMessage = 'Could not add product to cart.';
                    if (jqXHR.responseJSON && jqXHR.responseJSON.description) {
                        errorMessage = jqXHR.responseJSON.description;
                    }
                    console.error('Error adding to cart:', errorMessage);
                    alert('Error: ' + errorMessage);

                });

            });
        
    });



    if($(".reviews-section .slider-wrapper").length){

        $('.reviews-section .slider-wrapper').slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 10000,
            speed: 1000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });

    }


    function clearCart(formData, cb)
    {
        $.ajax({
            url: '/cart/clear.js',
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(formData)
        })
        .done(function(response) {
            cb(formData);
        });
    }

});